<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { nullCoalesce } from '@collector/shared-utils'
import { AttributeOption } from '@collector/sportsapi-client-legacy'

import IncrementableNumber from './IncrementableNumber.vue'

export default defineComponent({
  components: { IncrementableNumber },
  props: {
    value: {
      type: Object,
      required: true,
    },
    scoreBeforeChange: {
      type: Number,
      required: true,
    },
    wickets: {
      type: Object,
      required: true,
    },
    options: {
      type: Array as PropType<AttributeOption[]>,
      required: true,
    },
  },
  emits: ['update:value'],
  setup() {
    return {
      nullCoalesce,
    }
  },
})
</script>

<template>
  <IncrementableNumber
    :min="0"
    :max="9"
    :baseValue="scoreBeforeChange"
    @incremented="
      $emit(
        'update:value',
        options.find((option) => option.value === $event),
      )
    "
    @subtracted="
      $emit(
        'update:value',
        options.find((option) => option.value === $event),
      )
    "
  />
</template>
